// Documentation: https://chakra-ui.com/docs/theming/theme#z-index-values
// Default Theme zIndices: https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/foundations/z-index.ts
export const zIndices = {
  select: 1650,
  dayPicker: 1650,
};
